import type { Plan } from '@/fixtures/plans';

const PLAN_HIERARCHY: { name: Plan['name']; level: number }[] = [
  { name: 'Free', level: 1 },
  { name: 'Essentials', level: 2 },
  { name: 'Creator', level: 3 },
  { name: 'Pro', level: 4 },
  { name: 'Business', level: 5 },
];

/**
 * Level of a plan in the upgrade ladder — higher is a higher tier, 0 for an
 * unknown name. Compare two levels to decide whether a plan is an upgrade,
 * the current plan, or a downgrade.
 */
export const getPlanHierarchyLevel = (planName: Plan['name']) => {
  const match = PLAN_HIERARCHY.find((plan) => plan.name === planName);

  return match?.level ?? 0;
};
